export function getSplitTestVariant() {
  const splitTestCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('nf_ab'))
  return splitTestCookie ? splitTestCookie.split('=')[1] : 'default'
}
